import { render } from "./ZonesPage.vue?vue&type=template&id=2eca3c32&ts=true"
import script from "./ZonesPage.vue?vue&type=script&lang=ts"
export * from "./ZonesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Zones/ZonesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eca3c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eca3c32', __exports__)) {
    api.reload('2eca3c32', __exports__)
  }
  
  module.hot.accept("./ZonesPage.vue?vue&type=template&id=2eca3c32&ts=true", () => {
    api.rerender('2eca3c32', render)
  })

}


export default __exports__